import React, { useContext, useEffect, useState } from "react";
import { StyledBlueButton } from "../../styles/BootstrapStyles";
import { Form, Col } from "react-bootstrap";
import { ID_TYPES_VALUES, MEDIA_SEARCH } from "../../constants/MediaSearch";
import { MediaRequestContext } from "../../context/MediaRequestContext";
import "../../styles/media-search.scss";

const MediaSearchByIds = () => {
  const [validated, setValidated] = useState(false);
  const [invalidLength, setInvalidLength] = useState(false);
  const [error, setError] = useState("");
  const {
    idTypeValues,
    _setIdTypeValues,
    searchMediaById,
    _setSelectedOption,
    _setValidAssets,
    _setOdsEditsData,
    _setOdsSearchIdsData,
    _setIsPromoLoading,
    _setPromoError,
    idType
  } = useContext(MediaRequestContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    _setSelectedOption("");
    _setOdsEditsData({});
    _setOdsSearchIdsData({});
    _setValidAssets({});
    _setPromoError({});
    if (e.currentTarget.checkValidity() === false) {
      setValidated(false);
      setError("Required");
    } else if (e.currentTarget.checkValidity() && invalidLength) {
      setValidated(false);
    } else {
      _setIsPromoLoading(true);
      setValidated(true);
      searchMediaById();
    }
  };

  const getErrorMessage = () => {
    if (error === "Required") {
      return "This field is required";
    }

    if (idType[0] === ID_TYPES_VALUES.CUT_CID) {
      return "Please enter only 5 unique IDs.";
    }

    return "Please enter only 10 unique IDs.";
  };

  useEffect(() => {
    const ids = idTypeValues
      .split(/[\n,;]/)
      .map((str) => str.trim())
      .filter((id) => id);
    function uniq(a) {
      let seen = {};
      return a.filter(function (item) {
        return seen.hasOwnProperty(item) ? false : (seen[item] = true);
      });
    }

    const uniqueCount = uniq(ids).length;
    // NEW RULE -> if cutcid => max 5 IDs
    const maxAllowed = idType[0] === ID_TYPES_VALUES.CUT_CID ? 6 : 11;

    if (uniqueCount >= maxAllowed) {
      setInvalidLength(true);
      setError("Length");
    } else if (uniqueCount === 0) {
      setError("Required");
    } else {
      setInvalidLength(false);
      setError("");
    }
  }, [idTypeValues, idType]);

  return (
    <Form
      validated={validated}
      onSubmit={handleSubmit}
      className="search-by-ids-form"
    >
      <Form.Group
        className="media-search-textarea-group"
        as={Col}
        controlId="idTypeTextarea"
      >
        <Form.Control
          as="textarea"
          className="media-search-textarea-control"
          placeholder={idType[0] === ID_TYPES_VALUES.CUT_CID ? 
            MEDIA_SEARCH.cutIdTypePlaceholder : MEDIA_SEARCH.idTypeValuePlaceholder}
          autoComplete="off"
          value={idTypeValues}
          isInvalid={invalidLength}
          required
          onChange={(e) => {
            e.preventDefault();
            _setSelectedOption("");
            _setOdsEditsData({});
            _setOdsSearchIdsData({});
            _setValidAssets({});
            _setIdTypeValues(e.target.value);
          }}
        />
        <Form.Control.Feedback type="invalid">
          {getErrorMessage()}
        </Form.Control.Feedback>
      </Form.Group>
      <StyledBlueButton
        onClick={() => {}}
        type="submit"
        className="media-search-by-id-button"
      >
        Search
      </StyledBlueButton>
    </Form>
  );
};

export default MediaSearchByIds;
